import { cn } from '@/lib/utils';

interface MetricProps {
  value: string;
  label: string;
  /** `accent` for the numbers that carry the pitch, `muted` for the honest caveats. */
  tone?: 'accent' | 'plain' | 'muted';
  className?: string;
}

export function Metric({ value, label, tone = 'accent', className }: MetricProps) {
  return (
    <div className={cn('text-center', className)}>
      <p
        className={cn(
          'mb-1.5 text-2xl font-bold tabular-nums sm:text-3xl',
          tone === 'accent' &&
            'bg-gradient-to-r from-indigo-400 to-purple-400 bg-clip-text text-transparent',
          tone === 'plain' && 'text-white',
          tone === 'muted' && 'text-slate-400'
        )}
      >
        {value}
      </p>
      <p className="text-xs leading-relaxed text-slate-400 sm:text-[13px]">{label}</p>
    </div>
  );
}
